import { FileResponse } from '../services/api';

export const downloadPdf = (response: FileResponse | null, documentName?: string) => {
	if (!response) return;

	const downloadUrl = URL.createObjectURL(response.data);
	const link = document.createElement('a');
	link.href = downloadUrl;
	link.setAttribute('download', `${documentName ?? response.fileName}.pdf`);
	document.body.appendChild(link);
	link.click();
	link.remove();
	setTimeout(() => window.URL.revokeObjectURL(link.href), 7000);
};
